import { gql } from "@apollo/client";

export const GQL_ATECO_LIST = gql`
   query atecoList {
      atecoList {
         id
         code
         description
      }
   }
`;

export const GQL_WASTE_BIN_TYPES_LIST = gql`
   query wasteBinTypes {
      wasteBinTypes
   }
`;

export const GQL_UNIT_MEASURE_TYPES_LIST = gql`
   query unitMeasureTypes {
      unitMeasureTypes
   }
`;

export const GQL_CER_CODES = gql`
   query cerCodes($input: CERCodesInput) {
      cerCodes(input: $input) {
         id
         code
         description
         dangerous
         density_category {
            id
            name
            min_density
            max_density
            average_density
            created_at
            updated_at
         }
         recyclable
         recovery_type
         public_collection_bin
      }
   }
`;

export const GQL_CER_CODE_CATEGORY_DENSITY_LIST = gql`
   query cerCodeCategoryDensityList {
      cerCodeCategoryDensityList {
         id
         name
         min_density
         max_density
         average_density
         created_at
         updated_at
      }
   }
`;

export const GQL_CER_CODE_CATEGORY_DENSITY_FOR_COMUNE_LIST = gql`
   query cerCodeCategoryDensityListForComune($comune_code: String!) {
      cerCodeCategoryDensityListForComune(comune_code: $comune_code) {
         id
         densityCategory {
            id
            name
         }
         comune {
            id
            description
            code
         }
         min_density
         max_density
         average_density
         created_at
         updated_at
      }
   }
`;

export const GQL_CADASTAL_DATA_CATEGORY_LIST = gql`
   query cadastalDataCategoryList {
      cadastalDataCategoryList {
         id
         code
         description
      }
   }
`;

export const GQL_DOWNLOAD_FROM_S3 = gql`
   query downloadFromS3($input: DownloadS3Input!) {
      downloadFromS3(input: $input) {
         content
         filename
         filetype
      }
   }
`;

export const GQL_RECYCLING_OPERATIONS_LIST = gql`
   query recyclingOperationsList {
      recyclingOperationsList {
         id
         code
         description
      }
   }
`;

export const GQL_WASTE_COLLECTION_FREQUENCIES = gql`
   query wasteCollectionFrequencies {
      wasteCollectionFrequencies
   }
`;
